

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CJF28czl.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js","_app/immutable/chunks/BzTkbC3n.js","_app/immutable/chunks/D3QtGNvy.js","_app/immutable/chunks/DCQpVJ54.js"];
export const stylesheets = [];
export const fonts = [];
